import React from "react";

function ProductImagePlaceholder() {
    return (
        <div className="product-image-placeholder-container">
            <div className="product-image-placeholder-content">
                <i className="fas fa-image text-muted" style={{ fontSize: "1.5rem" }}/>
            </div>
        </div>
    )
}

export default React.memo(ProductImagePlaceholder);
